import sidebar from '@/config/sidebars/adminServiceTitan'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminServiceTitanTenants = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/service_titan/tenants/index.vue')
    createVueApp(IndexPage, { props, sidebar })
  },
  new: async(props) => {
    const { default: NewPage } = await import('@/vue_widgets/admin/service_titan/tenants/new.vue')
    createVueApp(NewPage, { props, sidebar })
  },
  edit: async(props) => {
    const { default: EditPage } = await import('@/vue_widgets/admin/service_titan/tenants/edit.vue')
    createVueApp(EditPage, { props, sidebar })
  }
}
